import React, {useEffect, useState} from 'react';

import { CustomSpinner } from '_atoms';

const LoadingScreenContainer = (props) => {

    return (
        <>
            <div style={{ opacity:props.loading ? 0.6 : 1.0 }}>
                {props.children}
            </div>
            { props.loading &&
            <div style={{ position:"absolute", top:'50%', left:'55%'}}>
                <CustomSpinner loading={true} />
            </div>
            }
        </>
    );
};

export default LoadingScreenContainer;
